export default __webpack_public_path__ + "static/media/apisDefault.52a8e63d.jpg";